import { useScrollIntoView } from 'modules/authentication';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { FieldWrapper } from 'shared/components';

interface Props {
  label: string;
  placeholder: string;
  inputSelector?: string;
}

export const StateInput: React.FC<Props> = ({
  label,
  placeholder,
  inputSelector,
}) => {
  const { formatMessage } = useIntl();
  const { handleFocus } = useScrollIntoView();

  const {
    formState: { errors },
    register,
  } = useFormContext<Settings>();

  return (
    <FieldWrapper name="address.state" errors={errors} labelId={label}>
      <input
        type="text"
        className={`input input__box input__med ${
          errors.address?.state ? 'input__box__error' : ''
        }`}
        placeholder={formatMessage({
          id: placeholder,
        })}
        data-cy={inputSelector}
        onFocus={handleFocus}
        {...register('address.state')}
      />
    </FieldWrapper>
  );
};
